import React from 'react';
import { Helmet } from "react-helmet";
import { Col, Row, Container } from 'reactstrap';
// Local Deps
import './About.scss';
import msgs from '../../../config/messages';
import aboutImg from '../../../images/about.png';
import image from '../../../images/75.jpeg';
import image2 from '../../../images/NFFS.png';
import ntma from '../../../images/ntma.png';
import dla from '../../../images/dla.png';
import dod from '../../../images/dod.png';
import ici from '../../../images/ici.png';
import metalFact from '../../../images/metalFact.jpg';
import afCat from '../../../images/afCat.png';
import castIt from '../../../images/castIt.png';

import {
  nffsRoute,
  dlaRoute,
  dodRoute,
  ntmaRoute,
  iciRoute,
  metalFactRoute,
  afCatRoute,
  castItRoute,
} from '../../../config/navigation/routes';

export default function About() {
  return (
    <Container>
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - About Page</title>
        <meta name="description" content="The ICON Portal simplifies the procurement process for cast parts by leveraging a tooling database of defense-related patterns and a database of foundries manufacturing those parts." />
        <meta name="keywords" content="amc icon, american metal casting consortium, cast metals industry, military castings" />
      </Helmet>

      <div className="nf-about">
        <Row>
          <Col xs={12}>
            <h1 className="nf-about__header">{msgs.About.header}</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={6} className="text-center">
            <img className="nf-about__img" src={aboutImg} alt="" />
          </Col>
          <Col xs={12} xl={6}>
            <div className="nf-about__section-text">
              {msgs.About.section1.text}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="nf-about__section-header">
              {msgs.About.section2.header}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <div className="nf-about__section-text">
              {msgs.About.section2.text}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="nf-about__section-text">
              {msgs.About.section2.text2}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="nf-about__section-text">
              {msgs.About.section2.text3}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="nf-about__section-header">
              {msgs.About.section3.header}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="nf-about__section-text">
              {msgs.About.section3.text}
            </div>
          </Col>
          <Col xs={12}>
            <div className="nf-about__section-text">
              {msgs.About.section3.text2}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="nf-about__section-header">
              {'Partners'}
            </h3>
          </Col>
          <div className="nf-about__section-text">
            <div style={{ float: 'left' }}>
              <a href={dlaRoute} target="_blank">
                <img style={{ width: '120px' }} src={dla} alt="" />
              </a>
            </div>
            <div style={{ float: 'left' }}>
              <a href={dodRoute} target="_blank">
                <img style={{ width: '120px' }} src={dod} alt="" />
              </a>
            </div>
            <div style={{ float: 'left' }}>
              <a href={ntmaRoute} target="_blank">
                <img style={{ width: '200px' }} src={ntma} alt="" />
              </a>
            </div>
            <div style={{ float: 'left' }}>
              <a href={iciRoute} target="_blank">
                <img style={{ width: '120px' }} src={ici} alt="" />
              </a>
            </div>
            <div style={{ float: 'left' }}>
              <a href={metalFactRoute} target="_blank">
                <img style={{ width: '120px' }} src={metalFact} alt="" />
              </a>
            </div>
            <div style={{ float: 'left' }}>
              <a href={afCatRoute} target="_blank">
                <img style={{ width: '120px' }} src={afCat} alt="" />
              </a>
            </div>
            <div style={{ float: 'left' }}>
              <a href={castItRoute} target="_blank">
                <img style={{ width: '200px' }} src={castIt} alt="" />
              </a>
            </div>
          </div>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="nf-about__section-header">From the Desk of the Non-Ferrous Founders’ Society (NFFS)</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="nf-about__section-header">Executive Director:</h3>
          </Col>
        </Row>
        <p>
          The ICON portal is a unique partnership between e Defense Logistics
          Agency (DLA) and the Foundry Industry. ICON helps drive a Procurement
          solution to buyers responsible for acquiring the replacement parts
          needed by our nation’s defense and military customers, domestic
          foundries and die casters.
          <br />
          <br />
          It drives value to stakeholders by providing innovative procurement
          solutions for defense and military related metal castings. For
          example, ICON uses a comprehensive industry capabilities database, and
          the nation’s largest database of foundry defense and military related
          tooling, to accurately direct bid requests from the DLA to foundries
          who have existing tooling; or, may not have tooling but are capable of
          manufacturing that component.
          <br />
          <br />
          In addition, the resultant goal is to assist DLA in the
          re-establishment of some of the diminished availability of supply
          chain parts; and, has made a major contribution to reducing the
          administrative and production lead times (PLT/ALT), in acquiring
          replacement metal castings. Many times, at a lower total cost to the
          Government by utilizing existing tooling and available industry
          capacity. We are excited about the release of our improved ICON portal
          and look forward to continuing to serve this country’s warfighters and
          the foundries that support them.
          <br />
          <br />
          Jerrod A. Weaver
          <br />
          Executive Director

          <a href={nffsRoute} target="_blank">
            <div>
              <img style={{ width: '150px' }} src={image} alt="" />
            </div>
            NON-FERROUS FOUNDERS’ SOCIETY
            <div style={{ marginTop: '10px' }}>
              <img style={{ width: '150px' }} src={image2} alt="" />
            </div>
          </a>
        </p>
      </div>
    </Container>

  );
}



// WEBPACK FOOTER //
// ./src/pages/static/About/About.jsx